/**
 * Adapted Markdown component.
 * Markdown doesn't need data adaptation - it uses inline content.
 */

import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import classes from './AdaptedGridComponent.module.css';
import type { ChatDashboardItem } from '#plugin-chat/components/dashboard/types.ts';
import { BlockError } from '#plugin-chat/components/shared/BlockError.tsx';
import { markdownTableComponents } from '#plugin-chat/lib/ui/markdown-table-components.tsx';

export interface AdaptedMarkdownProps {
  item: ChatDashboardItem;
}

export function AdaptedMarkdown({ item }: AdaptedMarkdownProps) {
  const { caption } = item;
  const markdownConfig =
    item.component.type === 'markdown' ? (item.component as { type: 'markdown'; content?: string }) : undefined;

  if (!markdownConfig?.content) {
    return <BlockError blockType="Markdown" message="Markdown requires component.content" />;
  }

  return (
    <div>
      {caption && <div className={classes.blockTitle}>{caption}</div>}
      <div className={classes.markdownText}>
        <Markdown components={markdownTableComponents} remarkPlugins={[remarkGfm]}>
          {markdownConfig.content}
        </Markdown>
      </div>
    </div>
  );
}
